/**
 * RISK-FAMILY-CARD
 * Card for one family
 */
import CardButton from "@/components/card-button"
import { RiskFamily } from "../model/risk-family.types"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { PhysicalRiskMeter } from "@/entities/physical-risk/ui/PhysicalRiskMeter"
import riskFamilyStore from "../model/risk-family.store"
import { getRiskFamilyImageUrl, RISK_FAMILY_IMAGE_STYLE } from "../model/risk-family.utils"
import type { RiskFamiliesDisplayMode } from "./RisksUserSettings"
import PeopleCount from "@/components/PeopleCount"

interface Props {
  family: RiskFamily
  onClick?: () => void
  displayMode?: RiskFamiliesDisplayMode
}

export default function RiskFamilyCard(props: Props) {
  const dispatch = useAppDispatch()

  //Selector
  const riskMax = useAppSelector((state) => physicalRiskStore.selectors.maxForFamily(state, props.family.id))
  const size = useAppSelector((state) => physicalRiskStore.selectors.sizeForFamily(state, props.family.id))
  const imageUrl = getRiskFamilyImageUrl(props.family)

  function handleClick() {
    if (props.onClick) {
      props.onClick()
    } else {
      dispatch(riskFamilyStore.actions.setActive(props.family))
    }
  }

  return (
    props.displayMode === "list" ? (
      <button
        className="_hover flex w-full items-center rounded-[12px] bg-white px-[16px] py-[6px] text-left"
        style={{ border: "1px solid #cccccc" }}
        onClick={handleClick}>
        <div className="mr-[16px] flex w-[38px] shrink-0 items-center justify-center">
          {riskMax && <PhysicalRiskMeter risk={riskMax} size="sm" />}
        </div>
        <span className="text-base">{props.family.name}</span>
        <PeopleCount className="ml-[8px]" count={size} />
        <div className="flex-1" />
        {imageUrl && (
          <div className="ml-[16px] flex h-[50px] w-[50px] shrink-0 items-center justify-center">
            <img
              className="h-[50px] w-[50px] object-contain"
              src={imageUrl}
              alt={props.family.name}
              onError={(e) => (e.currentTarget.style.display = "none")}
              style={RISK_FAMILY_IMAGE_STYLE}
            />
          </div>
        )}
      </button>
    ) : (
    <CardButton
      customLeftCorner={riskMax ? <PhysicalRiskMeter risk={riskMax} size="sm" /> : undefined}
      customRightCorner={
        size > 0 ? <PeopleCount count={size} /> : undefined
      }
      image={imageUrl}
      imageStyle={RISK_FAMILY_IMAGE_STYLE}
      isImageAlwaysVisible
      onClick={handleClick}
      title={props.family.name}
    />
    )
  )
}
